import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import {Home, Aboutus, Layanan, Portofolio, Contactus, Company, Layananlawfirm, Layananlegalitas, Layananagro, Layanankonstruksi, Layananadvertising, Layanantransport} from "./pages"
import {Footer, Navigation} from "./components"

function App() {

  return (
    <div className='App bg-slate-50'>
    <BrowserRouter>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/aboutus" element={<Aboutus />}></Route>
        <Route path="/layanan" element={<Layanan />}></Route>
        <Route path="/contactus" element={<Contactus />}></Route>
        <Route path="/portofolio" element={<Company />}></Route>
        <Route path="/layananlawfirm" element={<Layananlawfirm />}></Route>
        <Route path="/layananlegalitas" element={<Layananlegalitas />}></Route>
        <Route path="/layananagro" element={<Layananagro />}></Route>
        <Route path="/layanankonstruksi" element={<Layanankonstruksi />}></Route>
        <Route path="/layananadvertising" element={<Layananadvertising />}></Route>
        <Route path="/layanantransport" element={<Layanantransport />}></Route>
      </Routes>
      <Footer />
  </BrowserRouter>
  </div>
  );
}

export default App;
